import { createSelector } from '@mui/x-internals/store';
import { itemsSelectors } from "../items/selectors.mjs";
export const labelSelectors = {
  /**
   * Checks whether an item is editable.
   */
  isItemEditable: createSelector(state => state.isItemEditable, itemsSelectors.itemModel, (isItemEditable, itemModel, _itemId) => {
    if (!itemModel || isItemEditable == null) {
      return false;
    }
    if (typeof isItemEditable === 'boolean') {
      return isItemEditable;
    }
    return isItemEditable(itemModel);
  }),
  /**
   * Checks whether an item is being edited.
   */
  isItemBeingEdited: createSelector((state, itemId) => itemId == null ? false : state.editedItemId === itemId),
  /**
   * Checks whether any item is being edited.
   */
  isAnyItemBeingEdited: createSelector(state => !!state.editedItemId)
};